export const MANAGE_GROUPS = 'manage-groups';
export const FOOTER_ACTIONS = 'footer-actions';
